import {
  DriverStatus,
  MassMailingStatus,
  TimezoneCode,
} from '~/shared/config/enums'
import { myPalette } from '~/shared/lib/theme'

export const AUTH_TOKEN_STORAGE_KEY = 'auth_token'
export const AUTH_EMAIL_STORAGE_KEY = 'auth_email'
export const AUTH_CURRENT_USER_ID_STORAGE_KEY = 'auth_current_user_id'
export const USER_PERMISSIONS_STORAGE_KEY = 'user_permissions'

export const MIN_COLUMN_WIDTH = 90

export type Option = { id: string | number; label: string | number }
export type OptionEnum<T> = { id: T; label: string }

export const timezoneCodeLabels: Record<TimezoneCode, string> = {
  [TimezoneCode.KALININGRAD]: 'Калининград (UTC+2)',
  [TimezoneCode.MOSCOW]: 'Москва (UTC+3)',
  [TimezoneCode.SAMARA]: 'Самара (UTC+4)',
  [TimezoneCode.YEKATERINBURG]: 'Екатеринбург (UTC+5)',
  [TimezoneCode.OMSK]: 'Омск (UTC+6)',
  [TimezoneCode.KRASNOYARSK]: 'Красноярск (UTC+7)',
  [TimezoneCode.IRKUTSK]: 'Иркутск (UTC+8)',
  [TimezoneCode.YAKUTSK]: 'Якутск (UTC+9)',
  [TimezoneCode.VLADIVOSTOK]: 'Владивосток (UTC+10)',
  [TimezoneCode.MAGADAN]: 'Магадан (UTC+11)',
  [TimezoneCode.KAMCHATKA]: 'Камчатка (UTC+12)',
}

export const timezoneCodeOptions: OptionEnum<TimezoneCode>[] = Object.values(
  TimezoneCode,
).map((value) => ({
  label: timezoneCodeLabels[value as TimezoneCode],
  id: value as TimezoneCode,
}))

export const STATUS_VARIANT = {
  green: {
    backgroundColor: myPalette.green['100'],
    color: myPalette.green['600'],
  },
  red: {
    backgroundColor: myPalette.red['100'],
    color: myPalette.red['600'],
  },
  gray: {
    backgroundColor: myPalette.gray['100'],
    color: myPalette.gray['700'],
  },
  yellow: {
    backgroundColor: myPalette.yellow['100'],
    color: myPalette.yellow['600'],
  },
}

export const driverStatusLabels: Record<DriverStatus, string> = {
  [DriverStatus.CREATED]: 'Создано',
  [DriverStatus.CHECKS_STARTING]: 'Проверки начаты',
  [DriverStatus.CHECKING]: 'Проверка',
  [DriverStatus.CHECKS_FINISHED]: 'Проверки завершены',
  [DriverStatus.CHECKS_EXPIRED]: 'Проверки просрочены',
  [DriverStatus.ADDITIONAL_APPROVAL_REQUESTED]:
    'Запрос на дополнительное утверждение',
  [DriverStatus.CHECKS_CANCELLATION_REQUESTED]: 'Запрос на отмену проверок',
  [DriverStatus.CHECKS_RETRY_REQUESTED]: 'Запрос на повторную проверку',
  [DriverStatus.REJECTED]: 'Отклонено',
  [DriverStatus.REJECT_IN_PROGRESS]: 'Отклонение в процессе',
  [DriverStatus.APPROVE_IN_PROGRESS]: 'Принятие в процессе',
  [DriverStatus.APPROVED]: 'Утверждено',
  [DriverStatus.CHECKS_CANCELLED]: 'Проверки отменены',
  [DriverStatus.SENT_TO_COMANDIR]: 'Отправляется руководителю',
  [DriverStatus.FIRED]: 'Уволен',
  [DriverStatus.WORKS]: 'Работает',
}

export const driverStatusOptions: OptionEnum<DriverStatus>[] = Object.keys(
  DriverStatus,
).map((value) => {
  const label = driverStatusLabels[value as keyof typeof DriverStatus]
  return {
    label,
    id: value as DriverStatus,
  }
})

export const massMailingStatusLabels: Record<MassMailingStatus, string> = {
  [MassMailingStatus.WAITING]: 'Ожидание',
  [MassMailingStatus.PROCESSING]: 'В процессе',
  [MassMailingStatus.FINISHED]: 'Завершено',
}

export const massMailingStatusOptions: OptionEnum<MassMailingStatus>[] =
  Object.values(MassMailingStatus).map((value) => ({
    label: massMailingStatusLabels[value as MassMailingStatus],
    id: value as MassMailingStatus,
  }))

export const massMailingStatusVariant: Record<
  MassMailingStatus,
  keyof typeof STATUS_VARIANT
> = {
  [MassMailingStatus.WAITING]: 'yellow',
  [MassMailingStatus.PROCESSING]: 'green',
  [MassMailingStatus.FINISHED]: 'gray',
}

export const driverStatusVariant: Record<DriverStatus, string> = {
  [DriverStatus.CREATED]: 'gray',
  [DriverStatus.REJECTED]: 'red',
  [DriverStatus.APPROVED]: 'green',
  [DriverStatus.CHECKING]: 'yellow',
  [DriverStatus.SENT_TO_COMANDIR]: 'brand',
  [DriverStatus.CHECKS_CANCELLED]: 'gray',
  [DriverStatus.CHECKS_EXPIRED]: 'gray',
  [DriverStatus.CHECKS_FINISHED]: 'gray',
  [DriverStatus.CHECKS_STARTING]: 'gray',
  [DriverStatus.CHECKS_RETRY_REQUESTED]: 'gray',
  [DriverStatus.ADDITIONAL_APPROVAL_REQUESTED]: 'gray',
  [DriverStatus.WORKS]: 'gray',
  [DriverStatus.FIRED]: 'gray',
  [DriverStatus.CHECKS_CANCELLATION_REQUESTED]: 'gray',
  [DriverStatus.REJECT_IN_PROGRESS]: 'gray',
  [DriverStatus.APPROVE_IN_PROGRESS]: 'gray',
}
